import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { employeeProjectModelSchema, envelopeSchema } from '../lib/schemas';

export type EmployeeProjectModel = z.infer<typeof employeeProjectModelSchema>;

export const employeeProjectModelService = {
  async getEmployeeProjectModels(): Promise<EmployeeProjectModel[]> {
    const result = await apiClient.get(apiUrl.employeeProjectModels(), {
      validate: envelopeSchema('employee_project_models', z.array(employeeProjectModelSchema)),
      deduplicate: true,
      context: 'getEmployeeProjectModels',
    });
    return result.employee_project_models;
  },

  async createEmployeeProjectModel(
    model: Partial<EmployeeProjectModel>
  ): Promise<EmployeeProjectModel> {
    const result = await apiClient.post(apiUrl.employeeProjectModels(), model, {
      validate: envelopeSchema('employee_project_model', employeeProjectModelSchema),
      context: 'createEmployeeProjectModel',
    });
    return result.employee_project_model;
  },

  async updateEmployeeProjectModel(
    id: string,
    model: Partial<EmployeeProjectModel>
  ): Promise<EmployeeProjectModel> {
    const result = await apiClient.put(apiUrl.employeeProjectModels(id), model, {
      validate: envelopeSchema('employee_project_model', employeeProjectModelSchema),
      context: 'updateEmployeeProjectModel',
    });
    return result.employee_project_model;
  },

  async deleteEmployeeProjectModel(id: string): Promise<void> {
    await apiClient.delete(apiUrl.employeeProjectModels(id), {
      context: 'deleteEmployeeProjectModel',
    });
  },
};
